import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { AppProvider, useApp } from '@/context/AppContext';
import { useData } from '@/context/DataContext';
import Sidebar from './Sidebar';
import Topbar from './Topbar';
import CreateModals from './modals/CreateModals';
import EditModals from './modals/EditModals';
import DeleteConfirm from './modals/DeleteConfirm';

function Toast() {
  const { toast } = useApp();
  if (!toast) return null;
  return (
    <div className="fixed bottom-6 left-1/2 z-[60] -translate-x-1/2 animate-fade-in-up rounded-full bg-foreground-950 px-5 py-2.5 text-sm font-semibold text-white">
      {toast}
    </div>
  );
}

function LoadingState() {
  return (
    <div className="flex flex-col items-center justify-center gap-3 py-24">
      <i className="ri-loader-4-line animate-spin text-3xl text-primary-500" />
      <p className="text-sm text-foreground-500">Veriler yükleniyor...</p>
    </div>
  );
}

function ErrorState({ message, retry }: { message: string; retry: () => void }) {
  return (
    <div className="flex flex-col items-center justify-center py-24 text-center">
      <div className="flex h-14 w-14 items-center justify-center rounded-full bg-accent-100 text-accent-700">
        <i className="ri-error-warning-line text-2xl" />
      </div>
      <p className="mt-4 font-heading text-base font-semibold text-foreground-800">Veriler yüklenemedi</p>
      <p className="mt-1 max-w-sm text-sm text-foreground-500">{message}</p>
      <button
        type="button"
        onClick={retry}
        className="mt-4 cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-primary-600"
      >
        Tekrar Dene
      </button>
    </div>
  );
}

function Shell() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const { loading, error, refresh } = useData();

  return (
    <div className="min-h-screen bg-background-50">
      <Sidebar open={mobileOpen} onClose={() => setMobileOpen(false)} />
      <div className="lg:pl-64">
        <Topbar onMenuClick={() => setMobileOpen(true)} />
        <main className="px-4 py-6 md:px-6 md:py-8">
          {loading ? <LoadingState /> : error ? <ErrorState message={error} retry={refresh} /> : <Outlet />}
        </main>
      </div>
      <CreateModals />
      <EditModals />
      <DeleteConfirm />
      <Toast />
    </div>
  );
}

export default function AppLayout() {
  return (
    <AppProvider>
      <Shell />
    </AppProvider>
  );
}